import React from 'react';
import { Modal, ScrollView, TouchableOpacity, View } from 'react-native';
import { Feather } from '@expo/vector-icons';
import Button from '../../../components/Button';
import { StandardText } from '../../../config/theme/globalStyles';

const ManageChannelsModal = ({
  visible,
  channels,
  onClose,
  onCreate,
  onEdit,
  onDelete,
  onMove,
}) => {
  return (
    <Modal visible={visible} transparent animationType="fade">
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.45)' }}>
        <View style={{ width: '90%', maxWidth: 680, maxHeight: '90%', backgroundColor: '#FFFFFF', borderRadius: 10, padding: 16 }}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <StandardText color="#2e2e2e">Gerenciar canais</StandardText>
            <TouchableOpacity onPress={onClose}>
              <Feather name="x" size={20} color="#2e2e2e" />
            </TouchableOpacity>
          </View>

          <ScrollView>
            {channels.map((channel, index) => (
              <View
                key={channel.id}
                style={{ borderWidth: 1, borderColor: '#E5E5E5', borderRadius: 8, padding: 10, marginBottom: 8, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <View style={{ flex: 1, paddingRight: 8 }}>
                  <StandardText color="#2e2e2e">{channel.name}</StandardText>
                  <StandardText color="#7F7F7F" style={{ fontSize: 12 }}>
                    {channel.onlyAdminCanPost ? 'Somente admin posta' : 'Todos podem postar'}
                  </StandardText>
                </View>
                <View style={{ flexDirection: 'row' }}>
                  <TouchableOpacity
                    onPress={() => onMove(channel, 'up')}
                    disabled={index === 0}
                    style={{ padding: 6, marginRight: 4, opacity: index === 0 ? 0.3 : 1 }}
                  >
                    <Feather name="arrow-up" size={20} color="#2e2e2e" />
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => onMove(channel, 'down')}
                    disabled={index === channels.length - 1}
                    style={{ padding: 6, marginRight: 8, opacity: index === channels.length - 1 ? 0.3 : 1 }}
                  >
                    <Feather name="arrow-down" size={20} color="#2e2e2e" />
                  </TouchableOpacity>
                  <TouchableOpacity onPress={() => onEdit(channel)} style={{ marginRight: 12 }}>
                    <Feather name="edit-2" size={18} color="#2e2e2e" />
                  </TouchableOpacity>
                  <TouchableOpacity onPress={() => onDelete(channel)}>
                    <Feather name="trash-2" size={18} color="#D11A2A" />
                  </TouchableOpacity>
                </View>
              </View>
            ))}
          </ScrollView>

          <View style={{ marginTop: 12 }}>
            <Button title="Novo canal" onPress={onCreate} colorbutton="#3FC380a0" colortitle="#FFFFFF" />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default ManageChannelsModal;
